<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emWorkflowListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content">
            <div id="accordionFilter" class="content" v-menu-permission="'list'">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" :query-api="$_emWorkflowListMixin_queryApi"
                                           ref="emListFilter"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesPrdManBorrowProcessResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName" inlineActionsDisabled
                                      :query-api="$_emWorkflowListMixin_queryApi"
                                      :ref="modelName+'Table'" checkboxColumnDisabled editDisable
                                      with-custom-row-actions-first-column>
                                <template slot="left-header">
                                    <b-button-group>
                                        <em-button type="process"
                                                   class="btn btn-outline-primary btn-sm"
                                                   customLabel="发起人员借用"
                                                   confirmText="是否确认发起人员借用流程"
                                                   @click="submitManBorrowProcess">
                                        </em-button>
                                    </b-button-group>
                                </template>
                                <template slot="customRowActionsFirstColumn" slot-scope="customRowScope">
                                    <b-button-group>
                                        <em-button type="task"
                                                   v-bind:class="'btn btn-outline-primary btn-sm'"
                                                   @click="$_emWorkflowListMixin_handleApprove(customRowScope.row)">
                                        </em-button>
                                    </b-button-group>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    </div>
</template>
<script>
// Author LiangGangQiang
// Date 2021-08-19 16:46:21
import emWorkflowListMixin from "@/mixin/em/workflow/list";
import emCommonGotoMixin from "@/mixin/em/common/goto";

export default {
    name: "sithMesPrdManBorrowProcessWorkflowListView",
    mixins: [emWorkflowListMixin, emCommonGotoMixin],
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        }
    },
    mounted() {
        let query = this.$route.query;
        if (query.id !== undefined) {
            this.$_emGotoMixin_gotoHolderList(this.modelName
                , {idFilter: query.id}
                , {}, false, {
                    pathType: query.pathType,
                    id: query.id
                });
        }
    },
    methods: {
        submitManBorrowProcess() {
            this.$store.dispatch('api/put', {
                url: process.env.VUE_APP_SITHMES_PRD_URL + "/sithMesPrdManBorrowProcess", entity: {}
            }).then(response => {
                console.log(response);
                this.$message.success("操作成功");
                this.$refs.emListFilter.doQuery();
            })
        }
    }
};
</script>